import { render, staticRenderFns } from "./International.vue?vue&type=template&id=21a2cdec&scoped=true&"
import script from "./International.vue?vue&type=script&lang=js&"
export * from "./International.vue?vue&type=script&lang=js&"
import style0 from "./International.vue?vue&type=style&index=0&id=21a2cdec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a2cdec",
  null
  
)

export default component.exports